import { render, staticRenderFns } from "./AccountBalanceContent.vue?vue&type=template&id=ac4ae91c&lang=pug"
import script from "./AccountBalanceContent.vue?vue&type=script&lang=js"
export * from "./AccountBalanceContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports